// extracted by mini-css-extract-plugin
module.exports = {"container":"BackButton_container__2gSlH","backTitle":"BackButton_backTitle__4_P4f"};